const global={
  downloadapi:'/dev-api/', //生成环境"/prod-api/",
  assetsPublicPath:'/',
  agentId:1000013,
  casEnable:false, //设置为true 则启用cas认证
  casloginUrl:"http://ids.hljys.cn/cas/login?service=http://jw.hljys.cn:8088/app/#", //service填写app访问地址
  caslogoutUrl:"http://ids.hljys.cn/cas/logout",
  serverUrlPrefix:"http://ids.hljys.cn/cas/serviceValidate"
}
export default global;



//////////////////
// WEBPACK FOOTER
// ./static/gloabvar.js
// module id = Chm5
// module chunks = 1